export default __webpack_public_path__ + "static/media/coresanscr35-webfont.a4cb99fb.woff";